import { render, staticRenderFns } from "./RiwayatPesertaRpl.vue?vue&type=template&id=3bb4e095&"
import script from "./RiwayatPesertaRpl.vue?vue&type=script&lang=js&"
export * from "./RiwayatPesertaRpl.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatPesertaRpl.vue?vue&type=style&index=0&coped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports